、<template>
<span class="EditDevice">
    <el-button class="EditDeviceBtn" :type="btnType" @click="handleDialogShow">
        <slot name='btnText'>{{btnText ? btnText : $t(/*编辑*/'c.edit')}}</slot>
    </el-button>
    <el-dialog class="EditDeviceDialog" :title="$t(form.vehicle_id ? /*编辑*/'c.edit' : /*新增*/'c.add')+$t(/*设备*/'device.device')" @close="handleDialogClose"
        :visible.sync="dialogShow" :modal-append-to-body="false" :close-on-click-modal="false"  width="500px">
        <div class="dialog-container">
            <div class="form-item required">
                <div class="key">{{$t(/*设备UID*/'device.device_uid')}}</div>
                <div class="value">
                    <el-input :placeholder="$t(/*请输入*/'c.input')+$t(/*设备UID*/'device.device_uid')" v-model="form.uid"/>
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleDialogClose">{{$t(/*取消*/'c.cancel')}}</el-button>
            <el-button @click="handleDialogConfirm" type="primary">{{$t(/*确定*/'c.confirm')}}</el-button>
        </div>
    </el-dialog>
</span>
</template>

<script>
import Core from '../../../core'

export default {
    name: "EditDevice",
    components: {},
    props: {
        btnType: { type: String, default: 'text', },
        btnText: { type: String },

        space: { type: [String, Number], },
        detail: { type: Object, default: () => {return {}} }
    },
    data() {
        return {
            loading: false,
            dialogShow: false,

            form: {
                vehicle_id: '',
                space: '',
                uid: '',
                imei: '',
            },
        }
    },
    mounted() {
    },
    methods: {
        handleDialogShow() {
            if (this.detail.id) {
                for (const key in this.form) {
                    this.form[key] = this.detail[key] || ''
                }
                this.form.vehicle_id = this.detail.id
            }
            this.dialogShow = true
        },
        handleDialogClose() {
            this.dialogShow = false
            for (const key in this.form) {
                this.form[key] = ''
            }
        },
        handleDialogConfirm() {
            const f = Core.Util.deepCopy(this.form)
            if (!f.uid) {
                return this.$message.warning(this.$t(/*请输入*/'c.input')+ "设备ID");
            }
            f.space = f.space || this.space

            this.loading = true
            Core.Api.Vehicle.save(f).then(() => {
                this.$message.success(this.$t(/*操作成功*/'c.oper_success'));
                this.$emit('change')
                this.handleDialogClose();
            }).catch(err => {
                console.log('handleDialogConfirm err:', err)
                this.loading = false
            })
        },
    }

}
</script>

<style scoped lang="scss">
.EditDevice {
}
</style>
